/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for OrabankHookCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, OrabHookData, PaymentResponseDto } from "../models";

@Injectable({ providedIn: "root" })
export class OrabankHookCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    updateStatus(reference: string, bankReference: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateStatus(reference: string, bankReference: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateStatus(reference: string, bankReference: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateStatus(reference: string, bankReference: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/orab/status`;

        let params = new HttpParams();
        if (reference != null) {
            params = HttpParamsBuilder.addToHttpParams(params, reference, 'reference');
        }
        if (bankReference != null) {
            params = HttpParamsBuilder.addToHttpParams(params, bankReference, 'bankReference');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    orabhook(orabHookData: OrabHookData, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    orabhook(orabHookData: OrabHookData, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    orabhook(orabHookData: OrabHookData, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    orabhook(orabHookData: OrabHookData, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/orab`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: orabHookData,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getStatus(reference: string, bankReference: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    getStatus(reference: string, bankReference: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    getStatus(reference: string, bankReference: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    getStatus(reference: string, bankReference: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/orab/${reference}/${bankReference}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
